import React, { useState } from "react";
import Box from "@mui/material/Box";
import AssetModal from "./AssetModal";
import { ProjectProvider } from "../../../../contexts/project";

export default function AssetDetailsModal({ asset, reFetch, onClose }) {
  const [open, setOpen] = useState(false);

  const handleToggle = () => {
    setOpen(v => !v);
    if (onClose && open) onClose();
  };

  return (
    <>
      <Box
        underline="none"
        sx={{ cursor: "pointer" }}
        color="primary.main"
        className="unfocus"
        onClick={handleToggle}
      >
        {asset.itemId}
      </Box>
      {open && (
        <ProjectProvider id={asset.project.id} loadingComponent={<span />}>
          <AssetModal id={asset.id} reFetch={reFetch} onClose={handleToggle} open={open} />
        </ProjectProvider>
      )}
    </>
  );
}
